import React, { useState } from "react";
import { FaInfoCircle } from "react-icons/fa";
import AssessmentRecordsPage from "./Report";
import VendorReport from "./VendorReport";
import { motion } from "framer-motion";

function ConductedReportTabs() {
  const [activeTab, setActiveTab] = useState("own"); // 'own' selected by default
  const [showModal, setShowModal] = useState(false);

  const userType = localStorage.getItem("userType");

  return (
    <div className="min-h-screen bg-gradient-to-br from-white to-gray-50 p-6">
      <motion.div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between px-4 md:px-0"
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
      >
        <div className="flex items-center justify-center max-md:justify-start md:justify-start gap-2 max-md:ml-4 px-6 max-md:px-0">
          <h2 className="text-2xl font-bold text-gray-800">Conducted Result</h2>
          <button
            onClick={() => setShowModal(true)}
            className="md:hidden"
            aria-label="More info"
          >
            <FaInfoCircle
              size={18}
              className="text-gray-600 hover:text-blue-800 transition ml-4"
            />
          </button>
        </div>

        {/* Tabs */}
        {/* {userType === "manager" ?
          <div className="flex bg-gray-200 rounded-full p-1 w-full max-w-xs mx-auto md:mx-0">
            <button
              onClick={() => setActiveTab("own")}
              className={`flex-1 py-2 text-sm rounded-full transition-all ownReportButtonTooltip ${activeTab === "own" ? "bg-white shadow text-black" : "text-gray-500"
                }`}
            >
              Own Report
            </button>
          </div>
          :
          <div className="flex bg-gray-200 rounded-full p-1 w-full max-w-xs mx-auto md:mx-0">
            <button
              onClick={() => setActiveTab("own")}
              className={`flex-1 py-2 text-sm rounded-full transition-all ownReportButtonTooltip ${activeTab === "own" ? "bg-white shadow text-black" : "text-gray-500"
                }`}
            >
              Own Report
            </button>
            <button
              onClick={() => setActiveTab("vendor")}
              className={`flex-1 py-2 text-sm rounded-full transition-all vendorReportButtonTooltip ${activeTab === "vendor" ? "bg-white shadow text-black" : "text-gray-500"
                }`}
            >
              Vendor Report
            </button>
          </div>

        } */}

        {/* Info icon for desktop (if you want it) */}
        <div className="hidden md:flex justify-end">
          <button onClick={() => setShowModal(true)}>
            <FaInfoCircle
              size={20}
              className="text-gray-600 hover:text-blue-800 transition"
            />
          </button>
        </div>
      </motion.div>

      {activeTab === "own" && <AssessmentRecordsPage reportType="own" />}
      {activeTab === "vendor" && <VendorReport reportType="vendor" />}

      {showModal && (
        <div className="fixed inset-0 bg-black/30 backdrop-blur-sm flex items-center justify-center z-50">
          <div className="relative bg-white rounded-lg shadow-lg p-6 w-11/12 max-w-md">

            {/* Cross button */}
            <button
              onClick={() => setShowModal(false)}
              className="absolute top-4 right-4 text-black hover:text-gray-600"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>

            {/* Dynamic content based on tab */}
            <>
              <h3 className="text-lg font-semibold mb-2">Report Info</h3>
              <p className="text-sm text-gray-700">
                These reports reflect assessments you personally conducted for candidates. The results are based on your direct evaluations and interactions during the assessment process.
              </p>
            </>
            {/* <>
              <h3 className="text-lg font-semibold mb-2 mt-6">Vendor Report Info</h3>
              <p className="text-sm text-gray-700">
                These reports were created from assessments conducted by third-party vendors on behalf of your company. They allow you to review external evaluations and compare them with those conducted internally.
              </p>
            </> */}
          </div>
        </div>
      )}
    </div >
  );
}
export default ConductedReportTabs;
